import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  centered?: boolean;
  className?: string;
}
export function SectionHeading({
  title,
  centered = true,
  className = ''
}: SectionHeadingProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} className={`mb-12 ${centered ? 'text-center' : 'text-left'} ${className}`} data-id="element-814">
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-text mb-6 text-balance" data-id="element-815">
        {title}
      </h2>
      <div className={`h-1 w-24 bg-brand-gold rounded-full ${centered ? 'mx-auto' : ''}`} data-id="element-816" />
    </motion.div>;
}